<template>
  <div class="box3-3">
    <div class="title">
      <h3 style="font-size: 28px; color: #242526; font-weight: 700">
        {{ $t("home.scheme") }}
      </h3>
      <p style="font-size: 0.875rem; color: #7e7e7e; margin-top: 0.625rem">
        {{ $t("home.us1") }} I {{ $t("home.us2") }} I {{ $t("home.us3") }} I
        {{ $t("home.us4") }}
      </p>
    </div>
    <div class="bod" style="padding: 0 0 1.875rem">
      <el-container>
        <el-main>
          <el-row>
            <el-col
              :span="6"
              v-for="(item, index) in chanPingList"
              :key="index"
            >
              <div
                v-if="item.isShelves == true"
                class="item"
                @click="actionProduct(item.id)"
              >
                <div
                  class="img-bg"
                  :class="{ 'new-product': item.id == 665 || item.id == 679 }"
                  :style="{
                    backgroundImage: `url(${
                      item.pictureList && item.pictureList.length > 0
                        ? item.pictureList[0]
                        : ''
                    })`,
                  }"
                ></div>

                <div class="jia">￥{{ item.price }}</div>
                <div class="tit">
                  <div class="h2">{{ item.productModel }}</div>
                  <div class="h3">{{ getText(item, "title") }}</div>
                  <pre class="tex">{{ getText(item, "subtitle") }}</pre>
                  <pre class="tex">{{ getText(item, "categoryName") }}</pre>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </div>
    <!-- <span @click="daying()"></span> -->
    <div class="bijiao" v-if="store.bijiaoProduct.length > 0">
      <div class="title">
        <strong>{{ $t("home.productCompare") }}</strong>
      </div>
      <ul>
        <li v-for="item in store.bijiaoProduct" :key="item.id">
          <div class="img">
            <img v-if="item.pictureList" :src="item.pictureList[0]" alt="666" />
          </div>
          <div class="name">{{ item.title }}</div>
          <div class="content">{{ item.subtitle }}</div>
          <div class="close">
            <i class="el-icon-close" @click="actionBiJiao(item)"></i>
          </div>
        </li>
      </ul>

      <div class="but" @click="goBiJiao">{{ $t("home.compareProduct") }}</div>
    </div>
  </div>
</template>

<script>
import Store from "../store";
import { getLang } from "../plugins/common";
export default {
  toMenu(item) {
    if (this.$route.path !== item.url) {
      this.$router.push({ path: item.url });
    }
  },

  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });

    this.searchProduct();
    this.routeWatcher = this.$watch(
      () => this.$route,
      (to) => {
        if (to.query.random !== this.random) {
          this.random = to.query.random;
          this.searchProduct();
        }
      }
    );
  },
  data() {
    return {
      store: Store.state,
      // 产品列表
      chanPingList: [],
      titleLike: undefined,
      pageSize: 9999,
    };
  },
  methods: {
    async searchProduct() {
      let { data: res } = await this.$http.post("/c/product/queryc", {
        pageSize: this.$route.query.pageSize,
        titleLike: this.$route.query.titleLike,
      });
      this.chanPingList = res.data.records;
    },
    getText(parntProp, prop) {
      return getLang(this.$i18n.locale, parntProp, prop);
    },
    // 选中某个产品
    async actionProduct(id) {
      console.log(id);
      Store.setActionProduct(id);
      this.$router.push({
        path: "/product",
        query: {
          productId: id,
        },
      });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.new-product {
  position: relative; /* 设置容器相对定位 */
}

.new-product::after {
  content: ""; /* 对于图标，content为空 */
  display: block; /* 或inline-block，取决于需要 */
  width: 80px; /* 图标宽度 */
  height: 80px; /* 图标高度 */
  background-image: url("../assets/images/new.svg"); /* 图标路径 */
  background-size: cover; /* 使图标适应容器大小 */
  position: absolute; /* 设置绝对定位 */
  top: -50px; /* 距离容器顶部距离 */
  right: 0; /* 距离容器右侧距离 */
}

.box3-1 {
  height: 25rem;
  background-color: #e0edeb;
  text-align: center;
  .el-row {
    padding: 2.5rem 0;
    .el-col {
      padding-top: 1.875rem;
      img {
        width: 7.1875rem;
        height: 8.75rem;
      }
      .gif {
        display: none;
      }
      .liuliang {
        width: 11.25rem;
        height: 4.375rem;
        margin: 2.5rem 0;
      }
    }
    .el-col:hover {
      img {
        display: none;
      }
      .gif {
        display: inline-block;
      }
    }
  }
}
.box3-2 {
  height: 25rem;
  background-color: #caccce;
  text-align: center;
  .el-row {
    padding: 2.5rem 0;
    .el-col {
      padding-top: 1.875rem;
      img {
        width: 7.1875rem;
        height: 8.75rem;
      }
      .gif {
        display: none;
      }
      .liuliang {
        width: 11.25rem;
        height: 4.375rem;
        margin: 2.5rem 0;
      }
    }
    .el-col:hover {
      img {
        display: none;
      }
      .gif {
        display: inline-block;
      }
    }
  }
}
.box3-3 {
  // height: 25rem;
  background-color: #d6e1f2;
  .title {
    padding: 5.625rem 0;
    line-height: 1.875rem;
    text-align: center;
  }
  .bod {
    background-color: rgb(235, 240, 244);
  }

  .el-container {
    // background-color: #fff;
    width: 100%;
    .el-aside {
      min-height: 3.75rem;
      color: #fff;
      // border-radius:  0 1.875rem 1.875rem 0;
      ul {
        min-height: 75rem;
        background-color: rgb(42, 54, 66);
        border-radius: 0 1.25rem 1.25rem 0;
        padding-left: 3.75rem;
        padding-top: 0.625rem;
        padding-bottom: 6.25rem;
        li {
          .shaiTitle {
            padding-top: 0.625rem;
            border-bottom: 0.0625rem solid #fff;
            line-height: 3em;
            margin-top: 1.875rem;
            color: #4abcb9;
            margin-bottom: 1.25rem;
            img {
              width: 2.1875rem;
              height: 2.1875rem;
              float: left;
              margin-right: 0.625rem;
            }
            i {
              font-size: 1.5rem;
            }
          }
          .shaiBod {
            padding-top: 1.25rem;
            line-height: 2.5rem;
            color: #fff;
            .el-slider {
              width: 90%;
              display: inline-block;
            }
          }
          // 温度
          .wendu {
            // width: 10%;
            .but {
              width: 1.375rem;
              height: 1.375rem;
              border-radius: 50%;
              margin: 0 auto;
              margin-bottom: 3.125rem;
              transform: translateY(0.5rem);
              background-color: #fff;
            }
            text-align: center;
            .el-button {
              // margin-top: -6.25rem;
              transform: translateY(-2.8125rem);
            }
          }
          .wendu /deep/ .el-slider__bar {
            background-color: #f0442e !important;
          }
          .wendu /deep/ .el-slider__button {
            background-color: #f0442e;
            border: none;
          }
          .yali {
            .but {
              width: 0.3125rem;
              height: 1.25rem;
              // border-radius: 50%;
              margin: 0 auto;
              margin-bottom: 3.125rem;
              transform: translateY(0.5rem);
              background-color: #fff;
            }
            text-align: center;
            .el-button {
              // margin-top: -6.25rem;
              transform: translateY(-2.8125rem);
            }
          }
          .yali /deep/ .el-slider__button {
            width: 0.125rem;
            border-radius: 0rem;
            background-color: #4abcb9;
          }
          // .weizhi{
          //   width: 60%;
          //   height: 5rem;
          //   border-radius: .3125rem;
          //   border: .125rem solid #4abcb9 ;
          //   background-color: #4abcb922;
          //   position: relative;
          //   img{
          //     width: 1.875rem;
          //     height: 1.875rem;
          //   }
          //   .ding{
          //     position: absolute;
          //     top: 0;
          //     left: 50%;
          //     transform: translateY(-110%);
          //   }.di{
          //     bottom: 0;
          //     position: absolute;
          //     left: 50%;
          //     transform: translateY(110%) rotate(180deg);
          //   }.ce{
          //     position: absolute;
          //     top: 0;
          //     right: 0;
          //     transform: translateX(160%) rotate(90deg);
          //   }
          // }
          .guocheng {
            width: 3.4375rem;
            height: 4.0625rem;
            display: inline-block;
            margin: 0 0.1875rem;
            padding: 0.1875rem;
            border-radius: 0.3125rem;
            text-align: center;
            border: 0.0625rem solid transparent;

            img {
              width: 1.875rem;
              height: 2.5rem;
            }
            .fll {
              height: 2.5rem;
              width: 2.5rem;
            }
            .sj {
              width: 1.25rem;
            }
            .psq {
              margin-top: 0.9375rem;
              height: 0.625rem;
              margin-bottom: 0.9375rem;
            }
            .ld {
              margin-top: 1.25rem;
              height: 1.25rem;
            }
            .csd {
              margin-top: 1.5625rem;
              height: 0.9375rem;
            }
            position: relative;
            // .bg {
            //   width: 11.25rem;
            //   height: 5rem;
            //   background-color: #4abcb82c;
            //   border: .0625rem solid #4abcb9;
            //   position: relative;
            //   left: 0;
            //   top: 3.75rem;
            // }
            .ding {
              width: 5rem;
              font-size: 0.875rem;
              position: absolute;
              top: 30%;
              left: 50%;
            }
            .ce {
              position: absolute;
              right: -8.125rem;
              top: -10%;
              img {
                transform: rotate(90deg);
              }
            }
            .di {
              position: absolute;
              width: 5rem;
              bottom: -60%;
              left: -150%;
              img {
                transform: rotate(180deg);
              }
            }
            &:not(.weizhi) {
              &:hover {
                background-color: rgba(14, 13, 13, 0.385);
                border: 0.0625rem solid #999;
                position: relative;
              }
            }
          }
          .active {
            background-color: rgba(14, 13, 13, 0.385);
            border: 0.0625rem solid #999;
            position: relative;
            .actimg {
              position: absolute;
              width: 1.125rem;
              height: 1.125rem;
              top: 0;
              right: 0;
              transform: translate(50%, -50%);
              border-radius: 50%;
            }
          }
        }
        .weizhiLi {
          position: relative;
          .bg {
            width: 60%;
            height: 5rem;
            margin: 3.75rem 0;
            // border-radius: .625rem;
            border: 0.0625rem solid rgb(74, 186, 184);
            background-color: rgb(48, 77, 87);
          }
          img {
            width: 1.875rem;
            height: 2.1875rem;
          }
          .ding {
            position: absolute;
            top: 25%;
            left: 20%;
          }
          .ce {
            position: absolute;
            left: 63%;
            top: 45%;
            img {
              transform: rotate(90deg);
            }
          }
          .di {
            position: absolute;
            bottom: 5.3125rem;
            left: 20%;
            img {
              transform: rotate(180deg);
            }
          }
          .active {
            border: none !important;
            background: none !important;
          }
          .ce,
          .di,
          .ding {
            .actimg {
              display: none;
            }
          }
          .ce.wzAct,
          .ce:hover {
            // background-color: #fff;
            .actimg {
              width: 1rem;
              height: 1rem;
              position: absolute;
              border-radius: 50%;
              left: -110%;
              transform: rotate(0deg);
              line-height: 1.5625rem;
              display: block;
            }
          }
          .di.wzAct,
          .di:hover {
            // background-color: #fff;
            .actimg {
              width: 1rem;
              height: 1rem;
              position: absolute;
              // top: -110%;
              border-radius: 50%;
              transform: translate(1.875rem, -150%);
              display: block;
            }
          }
          .ding.wzAct,
          .ding:hover {
            // background-color: red;
            .actimg {
              width: 1rem;
              height: 1rem;
              position: absolute;
              border-radius: 50%;
              bottom: 0;
              left: 30%;
              transform: translateY(110%);
              display: block;
            }
          }
        }
      }
    }
    .el-main {
      padding: 1.25rem 0 1.25rem;
      .item {
        height: 27.5rem;
        margin: 1.25rem 0.9375rem;
        border-radius: 0.9375rem;
        box-shadow: 0 0 0.9375rem #ddd;
        position: relative;
        border: 0.0625rem solid #ddd;
        transition: 0.5s;
        padding: 1.5rem;
        img,
        .img-bg {
          // float: left;
          // margin-left: 2.5rem;
          display: block;
          margin: 0 auto;
          width: 11.25rem;
          height: 11.25rem;
          // margin-top: 1.25rem;
          // padding-top: 1.25rem;
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
        .jia {
          position: absolute;
          right: 0;
          bottom: 1.875rem;
          display: inline-block;
          background-color: rgb(74, 186, 184);
          color: #fff;
          height: 1.6875rem;
          min-width: 5rem;
          padding: 0 0.625rem;
          text-align: center;
          line-height: 1.6875rem;
          border-radius: 0.8438rem 0 0 0.8438rem;
        }
        .tit {
          position: relative;
          // top: 45%;
          // left: 1.5rem;
          .h2 {
            line-height: 2.5rem;
            color: rgb(74, 186, 184);
            font-size: 1.3125rem;
          }
          .h3 {
            line-height: 1.875rem;
            font-size: 20px;
            height: 3em;
            margin: 0;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            font-weight: 700;
          }
          .tex {
            position: relative;
            color: #718096;
            width: 100%;
            padding-left: 0.625rem;
            padding-top: 1.25rem;
            line-height: 1.5625rem;
            word-break: break-all;
            word-wrap: break-word;
            white-space: pre-wrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            cursor: default;
            font-family: Helvetica Neue, Helvetica, PingFang SC,
              Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
            font-size: 16px;
          }
        }
        .bi {
          position: absolute;
          left: 1.25rem;
          bottom: 1.25rem;
          .active {
            display: inline-block;
            width: 0.9375rem;
            height: 0.9375rem;
            border-radius: 0.1875rem;
            border: 0.0625rem solid #4abcb9;
            color: #fff;
            background-color: #4abcb9;
            line-height: 0.8125rem;
            font-size: 0.8125rem;
            text-align: center;
          }
          .notactive {
            transform: translateY(0.1875rem);
            width: 0.9375rem;
            height: 0.9375rem;
            border-radius: 0.1875rem;
            border: 0.0625rem solid #4abcb9;
            display: inline-block;
          }
        }
      }
      .item:hover {
        // background-color: #4abcb9;
        transform: translateY(-0.625rem);
        // margin-top: -0.3125rem;
        border: 0.0625rem solid #4abcb9;
      }
    }
  }
  .bijiao {
    width: 18.75rem;
    min-height: 18.75rem;
    background-color: #fff;
    position: fixed;
    right: 0;
    z-index: 999;
    bottom: 6.25rem;
    border-radius: 0.625rem;

    padding-bottom: 3.125rem;
    .title {
      line-height: 2.5rem;
      height: 2.5rem;
      font-size: 1.5625rem;
      margin: 0.625rem 0;
      padding: 0;
    }
    li {
      width: 95%;
      background-color: rgb(235, 240, 244);
      margin: 0.3125rem 2.5%;
      height: 4.375rem;
      display: grid;
      grid-template-columns: 5rem 1fr;
      grid-template-rows: 2.5rem 1.875rem;
      border-radius: 0.3125rem;
      position: relative;
      .img {
        grid-row-start: span 2;
        text-align: center;
        img {
          margin-top: 0.625rem;
          width: 3.125rem;
          height: 3.125rem;
        }
      }
      .name {
        font-size: 1.25rem;
        line-height: 2.5rem;
        color: rgb(74, 186, 184);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 90%;
      }
      .content {
        width: 90%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .close {
        position: absolute;
        top: 0.3125rem;
        right: 0.3125rem;
        z-index: 999;
      }
    }
    .but {
      width: 95%;
      height: 2.5rem;
      line-height: 2.5rem;
      background-color: #4abcb9;
      margin: 0 auto;
      position: absolute;
      bottom: 0.625rem;
      left: 2.5%;
    }
  }
}
</style>
